import styled from "styled-components";
import { InviteCopyButton, InviteLinkBox } from "../Invite/Invite.styled";

export const DepositContainer = styled.div`
  padding-inline: 15px;
`;

export const DepositLinkBox = styled(InviteLinkBox)`
  width: 100%;
  height: 40px;
  padding: 0 30px;
  border-radius: 20px;
`;

export const DepositPaidButton = styled(InviteCopyButton)`
  width: 40%;
  height: 40px;
  border-radius: 20px;
  text-transform: uppercase;
`;

export const DepositCopyButton = styled(InviteCopyButton)`
  width: 40%;
  height: 40px;
  border-radius: 20px;
  text-transform: uppercase;
`;
